import {useEffect, useRef} from 'react';

function useInterval(callback: () => void, delay: number | null) {
   const savedCallback = useRef(callback);
   const id = useRef<NodeJS.Timeout>();

   // Remember the latest callback if it changes.
   useEffect(() => {
      savedCallback.current = callback;
   }, [callback]);

   // Set up the interval.
   useEffect(() => {
      // Don't schedule if no delay is specified.
      if (delay === null) {
         id.current && clearInterval(id.current);
         return;
      }

      id.current = setInterval(() => savedCallback.current(), delay);

      return () => id.current && clearInterval(id.current);
   }, [delay, id]);
}

export default useInterval;
